module.exports = __webpack_public_path__ + "static/media/error.9c76fef5.svg";